<template>
  <el-dialog
    top="15vh"
    class="recipeType-edit__dialog"
    :title="row.id ? $t('Common.edit') : $t('Common.create')"
    width="800px"
    :close-on-click-modal="false"
    :before-close="close"
    :visible.sync="visible"
  >
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="auto"
      size="small"
      label-suffix=": "
    >
      <el-form-item :label="$t('RecipeManage.typeRecipeID')" prop="code">
        <el-input v-model="form.code" :placeholder="$t('RecipeManage.typeRecipeID')"></el-input>
      </el-form-item>
      <el-form-item label-width="0">
        <div style="display: flex">
          <p style="padding-right: 12px">
            <span style="color:#F56C6C">*</span>{{ $t('RecipeManage.typeRecipeTypeInfo') }}:
          </p>
          <div class="tableDiv">
            <el-table :data="typeNames" class="speTab">
              <el-table-column :label="$t('Common.lang')" width="140">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.language" class="speInput2">
                    <el-option
                      v-for="item in languageList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="typeNames.some((name) => name.language === item.value)"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('RecipeManage.typeRecipeTypeName')"
                prop="name"
                width="330px"
              >
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.name"
                    size="mini"
                    class="speInput"
                    :placeholder="$t('RecipeManage.typeRecipeTypeName')"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="date"
                :label="$t('Common.operation')"
                min-width="100"
                fixed="right"
              >
                <template slot-scope="scope">
                  <!--                <el-button-->
                  <!--                  v-if="typeNames && typeNames.length !== 1"-->
                  <!--                  type="text"-->
                  <!--                  size="mini"-->
                  <!--                  @click="deleteLang(scope.$index)"-->
                  <!--                  >删除</el-button-->
                  <!--                >-->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="$t('Common.delete')"
                    placement="top-start"
                  >
                    <div
                      class="iconDiv"
                      @click="deleteLang(scope.$index)"
                      v-if="typeNames && typeNames.length !== 1"
                    >
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-del_16"></use>
                      </svg>
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <div class="add-bt" @click="addLang">
              <span>+{{ $t('Common.create') }}</span>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item :label="$t('RecipeManage.typeRecipeImg')" prop="iconFileId">
        <Upload
          class="file__uploader"
          :img="form.iconFileId"
          accept="image/png,image/jpg,image/jpeg"
          @pickImg="pickImg"
        >
          <template slot="tip">{{ $t('Common.tips6') }}</template>
        </Upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="edit-footer">
      <hl-button type="border" @click="close">{{ $t('Common.cancel') }}</hl-button>
      <hl-button @click="save" :loading="loading">{{ $t('Common.save') }}</hl-button>
    </div>
  </el-dialog>
</template>

<script>
import HlButton from '../../../components/Button'
import Upload from '@/components/Upload'
import { uploadFile } from '@/utils/utils'
import { languageList } from '@/config/status.js'
export default {
  components: { HlButton, Upload },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    }
  },

  data() {
    return {
      languageList,
      typeNames: [{}],
      form: {},
      rules: {
        code: [{ required: true, message: this.$t('RecipeManage.typeRecipeID'), trigger: 'blur' }],
        iconFileId: [
          {
            required: true,
            message: this.$t('RecipeManage.typeRecipeImg'),
            trigger: ['change', 'blur']
          }
        ]
      },
      loading: false,
      clickActionOpions: [],
      pushUserOptions: []
    }
  },
  created() {
    if (this.row.id) {
      let params = {
        id: this.row.id
      }
      this.$ajax
        .get(this.$api.recipe.cookbookType_detail, params)
        .then((res) => {
          (this.form = res.data), (this.typeNames = res.data.typeNames)
          // this.form.roleId = (res.data.roleId && res.data.roleId.split(',')) || []
        })
        .catch(() => {})
    }
  },
  methods: {
    async pickImg(file) {
      if (file) {
        await uploadFile(file)
          .then((res) => {
            this.$set(this.form, 'iconFileId', res.data)
            // this.form.iconFileId = res.data
            // console.log('')
          })
          .catch(() => {})
      } else {
        this.form.iconFileId = ''
      }
    },
    // 添加语言
    addLang() {
      this.typeNames.push({})
    },
    // 删除语言
    deleteLang(index) {
      this.typeNames.splice(index, 1)
    },
    close() {
      this.$emit('update:visible', false)
    },
    checkForm() {
      let pass
      pass = this.typeNames.every((el) => {
        return el.language && el.name
      })
      if (!pass) {
        this.$message.warning(`${this.$t('RecipeManage.typeTips1')}`)
        return false
      }
      this.$refs.form.validate((valid) => {
        pass = valid
      })
      return pass
    },
    save() {
      if (!this.checkForm()) return
      this.loading = true
      let params = {
        iconFileId: this.form.iconFileId,
        typeNames: this.typeNames,
        code: this.form.code
      }
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      if (this.row.id) {
        params.id = this.row.id
      }
      let api = this.row.id
        ? this.$api.recipe.edit_cookbook_type
        : this.$api.recipe.add_cookbook_type
      this.$ajax
        .post(api, params, config)
        .then(() => {
          this.$message.success(
            `${this.row.id ? this.$t('Common.editSuccess') : this.$t('Common.createSuccess')}`
          )
          this.close()
          this.$emit('refresh')
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.recipeType-edit__dialog {
  /deep/.el-dialog__body {
    padding-left: 30px;
  }
  .iconDiv {
    width: 24px;
    height: 24px;
    cursor: pointer;
    border-radius: 4px;
    text-align: center;
    &:hover {
      background-color: rgba(32, 70, 199, 0.2);
    }
    &:active {
      background-color: rgba(32, 70, 199, 0.3);
    }
  }
  /deep/ .speInput {
    width: 310px !important;
    .el-input.el-input--small.el-input--suffix {
      width: 200px !important;
    }
  }
  /deep/ .speInput2 {
    width: 140px !important;
    .el-input.el-input--small.el-input--suffix {
      width: 120px !important;
    }
  }
  .tableDiv {
    background: #eff4fc;
    padding: 4px 16px 16px 16px;
    border-radius: 8px;
  }
  /deep/ .speTab {
    tr {
      background: #eff4fc !important;
    }
  }
  .add-bt {
    margin-top: 8px;
    width: 100%;
    background: #ffffff;
    border: 2px dashed #dcdfe6;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    span {
      color: #2046c7;
    }
    &:hover {
      background: #eff4fc;
      border-radius: 4px;
      border: 2px dashed #dadfe6;
    }
    &:active {
      background: #e3e8f0;
      border-radius: 4px;
      border: 2px solid #dadfe6;
    }
  }
}
</style>
